import { useState, useEffect } from 'react';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { showToast } from '../components/ui/Toast';
import { useSiteContent } from '../context/SiteContentContext';

const FIELDS = [
  'policy_returns_highlight', 'policy_returns_mto', 'policy_returns_damaged', 'policy_returns_repairs', 'policy_returns_cancel',
  'policy_shipping_highlight', 'policy_shipping_body', 'policy_privacy',
];

export default function AdminPolicies() {
  const { content, updateBulk } = useSiteContent();
  const [form, setForm] = useState({ ...content });
  const [saved, setSaved] = useState(true);
  const [tab, setTab] = useState('returns');

  // The saved text can arrive after this screen opens; show it unless
  // Andre has already started editing.
  useEffect(() => {
    if (saved) setForm({ ...content });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  function set(key, value) { setForm(prev => ({ ...prev, [key]: value })); setSaved(false); }
  const [saving, setSaving] = useState(false);
  async function save() {
    if (saving) return;
    setSaving(true);
    // Only this screen's fields, so nothing else is ever overwritten.
    const updates = {};
    FIELDS.forEach(k => { updates[k] = form[k] || ''; });
    const r = await updateBulk(updates);
    setSaving(false);
    if (r && r.error) { showToast(r.error, 'error'); return; }
    setSaved(true);
    showToast('Policies saved');
  }

  function field(key, label, type = 'textarea') {
    return (
      <div className="adm-field">
        <label className="adm-label">{label}</label>
        {type === 'textarea' ? (
          <textarea className="adm-textarea" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
        ) : (
          <input className="adm-input" value={form[key] || ''} onChange={e => set(key, e.target.value)} />
        )}
      </div>
    );
  }

  return (
    <div>
      <h1 className="adm-title">Policies</h1>
      <p className="adm-sub">Edit your returns, shipping, and privacy policies.</p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['returns','shipping','privacy'].map(t => (
          <button key={t} className={`adm-btn ${tab === t ? '' : 'adm-btn--outline'}`} onClick={() => setTab(t)} style={{ textTransform: 'capitalize' }}>
            {t}
          </button>
        ))}
      </div>

      {tab === 'returns' && (
        <div className="adm-card">
          {field('policy_returns_highlight', 'Highlight box')}
          {field('policy_returns_mto', 'Made-to-order policy')}
          {field('policy_returns_damaged', 'Damaged/defective policy')}
          {field('policy_returns_repairs', 'Repairs policy')}
          {field('policy_returns_cancel', 'Cancellation policy')}
        </div>
      )}

      {tab === 'shipping' && (
        <div className="adm-card">
          {field('policy_shipping_highlight', 'Highlight box')}
          {field('policy_shipping_body', 'Shipping details')}
        </div>
      )}

      {tab === 'privacy' && (
        <div className="adm-card">
          {field('policy_privacy', 'Privacy policy (full text)')}
        </div>
      )}

      <div className="adm-save-bar">
        <span className={`adm-save-status ${saved ? 'adm-save-status--saved' : ''}`}>
          {saved ? '✓ Saved' : '● Unsaved'}
        </span>
        <button className="adm-btn" onClick={save}><IconDeviceFloppy size={14} /> Save</button>
      </div>
    </div>
  );
}
